<script setup lang="ts">
import Accordion from "~/components/layout/TrackRacing/FixedOdds/DailyRaces/Accordion.vue";
import { IAntePostEvents } from "../AntePost/AntePost.vue";

interface Props {
	specialEvents: IAntePostEvents[];
}
const router = useRouter();
const route = useRoute();
defineProps<Props>();
</script>
<template>
	<Accordion v-for="region in specialEvents" :title="region.name" :region-id="region.events[0].regionId" :default-open="true">
		<template #content>
			<div class="overflow-x-auto">
				<div class="flex items-center h-[32px] text-xs font-bold bg-light-50 dark:bg-dark-700">
					<div class="my-auto mx-2">
						{{ region.name }}
					</div>
				</div>

				<div class="p-2">
					<div class="grid grid-cols-1 md:grid-cols-3 gap-2">
						<div
							v-for="event in region.events"
							@click="router.push({ query: { ...route.query, eventId: event.eventId } })"
							class="min-h-[42px] bg-light-50 dark:bg-dark-700 flex items-center p-2 text-xs w-full truncate rounded-md font-bold text-dark-400 dark:text-light-50 cursor-pointer"
						>
							{{ event.displayName }}
						</div>
					</div>
				</div>
			</div>
		</template>
	</Accordion>
</template>
